<template>
    <div>
        <!-- 案件危险源圆形范围 -->
        <LVector :zIndex="20" v-if="config.layerAuto.hasEmergencyDanger" ref="dangerCircleLayer">
            <LCircleFeature
                v-for="item in caseListAll"
                :obj="item"
                :center="[item.longitude, item.latitude]"
                :radius="Number(3000)"
                :key="item.id + '_circle'"
                :id="item.id + '_circle'"
                :defaultStyle="{
                    fill: {
                        color: 'rgba(222, 136, 104, 0.15)',
                    },
                    stroke: {
                        color: 'rgba(222, 136, 104, 1)',
                        width: 1,
                    },
                }"
            />
        </LVector>

        <!-- 案件危险源点位 -->
        <LVector :zIndex="21" :hoverFeature="hoverIncident" :selectFeature="selectIncident"
            v-if="config.layerAuto.hasEmergencyDanger" ref="dangerPointLayer">
            <LPointFeature
                v-for="item in caseListAll"
                :key="item.id + '_case'"
                :id="item.id"
                :defaultStyle="caseStyle(item)"
                :latitude="+item.latitude"
                :longitude="+item.longitude"
                :obj="item"
                :overlayOffset="[0, -66]"
                className="command-overlayer-danger-top"
                @click.native.stop
            >
                <div slot="labelOverlay" class="point-top danger" v-if="item.longitude" v-show="mapZoom >= 13.3">
                    {{ $t('yingji.emergencyCase.incidentPoint') }}
                </div>
            </LPointFeature>
        </LVector>

        <!-- 案件信息弹窗 -->
        <el-popover ref="caseDialog" v-model="visible" placement="top" trigger="manual" popper-class="caseDialog-popver el-popper-legend"
            :style="style">
            <div class="caseDialog" @mousedown="startDrag">
                <div class="caseDialog-title">
                    {{ $t('yingji.emergencyCase.caseSummary')  }}
                    <i class="el-icon-close" style="float: right; margin: 5px 5px 0 0; cursor: pointer;"
                        @click="handleCloseDialog"></i>
                </div>
                <div class="caseDialog-content">
                    <CaseDone
                        v-if="caseDialogObj.status == 2"
                        :caseDialogObj="caseDialogObj"
                        @close="handleCloseDialog"
                    />
                    <CasePending
                        v-else
                        :caseDialogObj="caseDialogObj"
                        @copy="copyFn"
                        @delete="showDelDialogFn"
                    />
                </div>
            </div>
        </el-popover>
    </div>
</template>

<script>
import {
    LVector,
    LPointFeature,
    OMapMixin,
    LCircleFeature,
} from '@OpenLayersCommon';
import { tool } from '@CesiumCommon';
import moment from 'moment';
import * as turf from '@turf/turf';
import { mapGetters } from 'vuex';
import api from '../api/index.js';
import CaseDone from './caseComponents/CaseDone.vue';
import CasePending from './caseComponents/CasePending.vue';

export default {
    mixins: [OMapMixin],
    props: {
        caseListAll: { type: Array, default: () => [] },
        dangerObj: { type: Object, default: null },
        dangerCoordinate: { type: Object, default: () => ({}) },
        userCheckList: { type: Array, default: () => [] },
        highRises: { type: Array, default: () => [] },
        noFlyZone: { type: Array, default: () => [] },
        heightLimitZone: { type: Array, default: () => [] },
        config: {
            type: Object,
            default: () => ({
                layerAuto: {},
                statiMapHives: [],
                selectDistance: '3km内',
                getDangerCoordinate: () => { },
                changeUserList: () => { },
                changeStatiMapHives: () => { },
                initUserList: () => { },
            }),
        },
    },
    components: {
        LVector,
        LPointFeature,
        LCircleFeature,
        CaseDone,
        CasePending,
    },
    data () {
        return {
            visible: false,
            mapZoom: 14.5,
            style: { position: 'absolute', top: '100px', left: '200px' },
            showCloseBtn: false,
            caseId: null,
            hoverIncidentObj: {},
            caseDialogObj: {},
            flagTime: null,
            // 拖拽相关变量
            dragInfo: {
                isDragging: false,
                disX: 0,
                disY: 0,
                popoverEl: null,
            },
            map: null,
            // 新增：低层级阈值（根据业务调整，默认10，低于该层级屏蔽点击逻辑）
            minClickZoom: 10,
        };
    },
    async mounted () {
        try {
            this.map = await this.getMap();
            this.changeZoom();
            if (this.map && this.map.getView()) {
                this.map.getView().on('change:resolution', this.changeZoom);
            }

            // 关键：添加图层置顶逻辑
            this.$nextTick(async () => {
                await this.moveDangerLayersToTop();

                // 监听图层添加事件，确保新增图层时危险源仍置顶
                if (this.map) {
                    this.map.on('layer:add', this.moveDangerLayersToTop);
                }
            });
        } catch (error) {
            console.error('初始化地图失败:', error);
        }
    },
    beforeDestroy () {
        // 安全移除事件监听
        if (this.map && this.map.getView()) {
            this.map.getView().un('change:resolution', this.changeZoom);
        }
        clearTimeout(this.flagTime);

        // 移除图层添加事件监听
        if (this.map) {
            this.map.un('layer:add', this.moveDangerLayersToTop);
        }

        // 移除拖拽事件监听
        this.stopDrag();
    },
    watch: {
        caseDialogObj: {
            handler (newVal) {
                console.log('caseDialogObj', newVal);
            },
            deep: true,
        },
        'config.layerAuto': {
            handler (newVal) {
                this.$nextTick(() => {
                    this.moveDangerLayersToTop();
                });
            },
            immediate: true,
            deep: true,
        },
        caseListAll: {
            handler (newVal) {
                if (newVal && newVal.length) {
                    let has = newVal.find((item) => item.id === this.caseDialogObj.id);
                    if (!has) {
                        this.visible = false;
                    }
                } else {
                    this.visible = false;
                }

                this.$nextTick(() => {
                    this.moveDangerLayersToTop();
                });
            },
            immediate: true,
            deep: true,
        },
        'config.selectDistance': {
            handler (newVal, oldVal) {
                if (newVal !== oldVal && typeof this.config.initUserList === 'function') {
                    this.config.initUserList();
                }
            },
        },
        showCloseBtn (val) {
            if (val) {
                this.flagTime = setTimeout(() => {
                    this.showCloseBtn = false;
                }, 2000);
            } else {
                clearTimeout(this.flagTime);
            }
        },
        // 新增：监听地图缩放级别，低层级时自动隐藏弹窗
        mapZoom (newVal) {
            if (newVal < this.minClickZoom) {
                this.visible = false;
            }
        },
    },
    computed: {
        ...mapGetters(['userInfo']),
        // 新增：计算是否允许触发点击事件（高于最低阈值才允许）
        isAllowClick () {
            return this.mapZoom >= this.minClickZoom;
        },
    },
    methods: {

        // 获取状态样式类
        getStatusClass (status) {
            const classMap = {
                0: 'status-pending',
                1: 'status-processing',
                2: 'status-done',
            };
            return classMap[status] || 'status-pending';
        },

        // 图层置顶：设置极高zIndex，确保显示在最上层
        async moveDangerLayersToTop () {
            try {
                const map = await this.getMap();
                if (!map) return;

                // 获取危险源图层实例
                const circleLayerComp = this.$refs.dangerCircleLayer;
                const pointLayerComp = this.$refs.dangerPointLayer;

                // 处理圆形范围图层
                if (circleLayerComp) {
                    const circleLayer = await circleLayerComp.getComponent();
                    if (circleLayer && circleLayer.setZIndex) {
                        // circleLayer.setZIndex(40);
                        if (circleLayer.setVisible) {
                            circleLayer.setVisible(true);
                        }
                    }
                }

                // 处理点位图层
                if (pointLayerComp) {
                    const pointLayer = await pointLayerComp.getComponent();
                    if (pointLayer && pointLayer.setZIndex) {
                        pointLayer.setZIndex(9999);
                        if (pointLayer.setVisible) {
                            pointLayer.setVisible(true);
                        }
                    }
                }

                // 强制刷新地图渲染，避免图层空白
                map.render();
            } catch (error) {
                console.error('设置危险源图层zIndex失败:', error);
                this.resetMapView();
            }
        },

        // 开始拖拽
        startDrag (e) {
            try {
                e.stopPropagation();
                const popoverEl = this.$refs.caseDialog?.$el;
                if (!popoverEl) return;

                this.dragInfo = {
                    isDragging: true,
                    disX: e.clientX - popoverEl.offsetLeft,
                    disY: e.clientY - popoverEl.offsetTop,
                    popoverEl,
                };

                document.addEventListener('mousemove', this.doDrag);
                document.addEventListener('mouseup', this.stopDrag);
            } catch (error) {
                console.error('开始拖拽失败:', error);
            }
        },

        // 执行拖拽
        doDrag (e) {
            try {
                e.stopPropagation();
                if (!this.dragInfo.isDragging || !this.dragInfo.popoverEl) return;

                // 获取地图容器
                let mapcontent = document.querySelector('.c-contentPage-content')
                    || document.querySelector('.map-content')
                    || document.body;

                // 计算新位置
                let left = e.clientX - this.dragInfo.disX;
                let top = e.clientY - this.dragInfo.disY;

                // 边界限制
                if (mapcontent) {
                    const mapRect = mapcontent.getBoundingClientRect();
                    const popoverRect = this.dragInfo.popoverEl.getBoundingClientRect();
                    const maxLeft = mapRect.width - popoverRect.width;
                    const maxTop = mapRect.height - popoverRect.height;

                    left = Math.max(mapRect.left, Math.min(left, mapRect.left + maxLeft));
                    top = Math.max(mapRect.top, Math.min(top, mapRect.top + maxTop));
                }

                // 更新弹窗位置
                this.dragInfo.popoverEl.style.left = `${left}px`;
                this.dragInfo.popoverEl.style.top = `${top}px`;
                this.style.left = `${left}px`;
                this.style.top = `${top}px`;
            } catch (error) {
                console.error('执行拖拽失败:', error);
                this.stopDrag();
            }
        },

        // 停止拖拽
        stopDrag () {
            try {
                document.removeEventListener('mousemove', this.doDrag);
                document.removeEventListener('mouseup', this.stopDrag);

                this.dragInfo = {
                    isDragging: false,
                    disX: 0,
                    disY: 0,
                    popoverEl: null,
                };
            } catch (error) {
                console.error('停止拖拽失败:', error);
            }
        },

        // 关闭弹窗（阻止冒泡）
        handleCloseDialog () {
            try {
                this.visible = false;
            } catch (error) {
                console.error('关闭弹窗失败:', error);
            }
        },

        // 显示删除确认弹窗
        showDelDialogFn () {
            this.$confirm(this.$t('yingji.emergencyCase.deleteConfirmMessage'), this.$t('yingji.emergencyCase.deleteConfirmTitle'), {
                confirmButtonText: this.$t('yingji.emergencyCase.confirm'),
                cancelButtonText: this.$t('yingji.emergencyCase.cancel'),
                type: 'warning',
            })
                .then(async () => {
                    await this.deleteCaseById();
                    if (typeof this.config.initUserList === 'function') {
                        this.config.initUserList();
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('yingji.emergencyCase.deleteCancelled'),
                    });
                });
        },

        // 删除案件
        async deleteCaseById () {
            try {
                this.showCloseBtn = false;
                if (typeof this.config.getDangerCoordinate === 'function') {
                    this.config.getDangerCoordinate(null);
                }
                this.$emit('update:dangerCoordinate', { latitude: '', longitude: '' });
                this.$emit('update:dangerObj', null);
                this.$emit('DeleteDataEvent', this.caseId, 'case');
            } catch (error) {
                console.error('删除案件失败:', error);
                this.$message.error(this.$t('yingji.emergencyCase.deleteFailed'));
            }
        },

        // 选中事件（新增低层级防护+强化参数校验+兜底）
        selectIncident (e, id, feature, obj) {
            try {
                console.log('[EmergencyCase] selectIncident 开始', { id, obj });
                if (this.$parent && this.$parent.showRoute) {
                    try {
                        this.$parent.showRoute(id, { ...obj });
                    } catch (err) {
                        this.resetMapView();
                    }
                }
            } catch (error) {
                this.resetMapView();
            }
        },

        // 鼠标悬停事件（新增低层级防护+阻止冒泡+空值校验）
        hoverIncident (e, id, feature, obj) {
            try {
                // 1. 低层级防护：低于阈值直接隐藏弹窗
                if (!this.isAllowClick) {
                    this.hoverIncidentObj = {};
                    this.visible = false;
                    this.showCloseBtn = false;
                    return;
                }

                // 2. 阻止事件冒泡
                e?.stopPropagation?.();
                e?.originalEvent?.stopPropagation?.();

                // 3. 空值校验
                if (!e || !obj) {
                    this.hoverIncidentObj = {};
                    this.visible = false;
                    this.showCloseBtn = false;
                    return;
                }

                // 4. 安全访问pixel_属性
                const pixel = e.pixel_;
                if (!pixel || !Array.isArray(pixel)) {
                    this.hoverIncidentObj = {};
                    this.visible = false;
                    this.showCloseBtn = false;
                    return;
                }

                // 5. 坐标有效性校验
                if (!obj.longitude || !obj.latitude) {
                    this.visible = false;
                    this.showCloseBtn = false;
                    return;
                }

                // 6. 正常处理逻辑
                this.hoverIncidentObj = { id, obj };
                let [x, y] = pixel;

                this.style.top = `${y - 10}px`;
                this.style.left = `${x + 10}px`;

                setTimeout(async () => {
                    this.caseId = obj.id || '';
                    this.showCloseBtn = true;
                    try {
                        const [imageRes, videoRes] = await Promise.all([
                            api.getCaseFileList({ caseId: obj.id, type: 'image' }),
                            api.getCaseFileList({ caseId: obj.id, type: 'video' }),
                        ]);
                        const imageData = imageRes.data?.data || imageRes.data || [];
                        const videoData = videoRes.data?.data || videoRes.data || [];
                        const imageVideoList = [...imageData, ...videoData];
                        this.caseDialogObj = {
                            ...obj,
                            imageVideoList,
                        };
                    } catch (error) {
                        console.error('获取案件媒体文件失败:', error);
                        this.caseDialogObj = {
                            ...obj,
                            imageVideoList: [],
                        };
                    }
                    this.visible = true;
                }, 50);
            } catch (error) {
                console.error('鼠标悬停事件失败:', error);
                this.visible = false;
                this.showCloseBtn = false;
                this.resetMapView();
            }
        },

        // 计算距离
        calcDistanceFn (point) {
            try {
                if (!point || !point.longitude || !point.latitude) return '否';

                let res = this.config.statiMapHives.some((item) => {
                    try {
                        if (!item || !item.longitude || !item.latitude) return false;
                        let from = turf.point([Number(item.longitude), Number(item.latitude)]);
                        let to = turf.point([Number(point.longitude), Number(point.latitude)]);
                        let distance = turf.distance(from, to);
                        return distance <= 3.25;
                    } catch (e) {
                        console.error('计算单个距离失败:', e);
                        return false;
                    }
                });
                return res ? '是' : '否';
            } catch (e) {
                console.error('计算距离失败:', e);
                return '否';
            }
        },

        // 复制坐标链接（加强校验+URL编码）
        copyFn (text) {
            try {
                // 解构赋值兜底
                let { longitude, latitude } = this.caseDialogObj || {};

                // 加强坐标校验
                const lng = Number(longitude);
                const lat = Number(latitude);
                if (!lng || !lat || isNaN(lng) || isNaN(lat)) {
                    this.$message.warning(this.$t('yingji.emergencyCase.copyCoordinateInvalid'));
                    return;
                }

                // 坐标转换+结果校验
                let newArr = tool.transform.wgs84togcj02(lng, lat);
                if (!Array.isArray(newArr) || newArr.length !== 2 || isNaN(newArr[0]) || isNaN(newArr[1])) {
                    this.$message.error(this.$t('yingji.emergencyCase.copyTransformFailed'));
                    return;
                }

                // URL编码特殊字符
                const encodeName = encodeURIComponent(text || '');
                const [gcjLng, gcjLat] = newArr;
                let str = `https://uri.amap.com/marker?position=${gcjLng},${gcjLat}&name=${encodeName}`;

                // 优先使用现代剪贴板API
                if (navigator.clipboard && window.isSecureContext) {
                    navigator.clipboard.writeText(str)
                        .then(() => {
                            this.$message.success(this.$t('common.copySuccess'));
                        })
                        .catch((err) => {
                            console.error('剪贴板 API 复制失败:', err);
                            this.fallbackCopyText(str);
                        });
                } else {
                    this.fallbackCopyText(str);
                }
            } catch (e) {
                console.error('复制功能异常:', e);
                this.$message.error(this.$t('yingji.emergencyCase.copyFailed'));
            }
        },

        // 降级复制方案
        fallbackCopyText (str) {
            try {
                let input = document.createElement('input');
                input.style.cssText = 'position: fixed; top: -1000px; left: -1000px; z-index: -999;';
                document.body.appendChild(input);

                input.value = str;
                input.focus();
                input.select();
                input.setSelectionRange(0, str.length);

                let result = false;
                try {
                    result = document.execCommand('copy');
                } catch (err) {
                    console.error('execCommand 复制失败:', err);
                }

                document.body.removeChild(input);

                if (result) {
                    this.$message.success(this.$t('common.copySuccess'));
                } else {
                    this.$message.error(this.$t('yingji.emergencyCase.copyFailed'));
                }
            } catch (err) {
                console.error('降级复制方案异常:', err);
                this.$message.error(this.$t('yingji.emergencyCase.copyFailed'));
            }
        },

        // 判断区域包含
        getscreenlist (highRises, point) {
            try {
                if (!highRises || highRises.length === 0 || !point || !Array.isArray(point)) return '否';

                let pt = turf.point([Number(point[0]), Number(point[1])]);
                let poly = Array.isArray(highRises[0]) ? turf.polygon([highRises]) : turf.polygon(highRises);
                let status = turf.booleanPointInPolygon(pt, poly);
                return status ? '是' : '否';
            } catch (e) {
                console.error('判断区域包含失败:', e);
                return '否';
            }
        },

        // 生成点位样式（兜底处理）
        caseStyle (item) {
            try {
                let mapZoom = this.mapZoom || 13.3;
                let scale = (mapZoom - 13) * 0.2 + 0.6;
                if (scale < 0.6) scale = 0.6;
                if (scale > 1) scale = 1;
                return {
                    icon: {
                        src: require('./images/icon-danger.png'),
                        scale,
                        offset: [-15, 10],
                        size: [100, 100],
                    },
                    text: {
                        textAlign: 'center',
                        textBaseline: 'middle',
                        font: 'normal  14px  Microsoft YaHei-Regular, Microsoft YaHei',
                        text: mapZoom > 13.3 ? (item.location || '') : '',
                        offsetY: 40 * scale,
                        offsetX: 0,
                        fill: { color: '#FFFFFF' },
                        stroke: { color: '#000', width: 1 },
                        padding: [2, 5, 2, 5],
                    },
                };
            } catch (error) {
                console.error('生成样式失败:', error);
                // 返回默认样式兜底
                return {
                    icon: {
                        src: require('./images/icon-danger.png'),
                        scale: 0.8,
                        offset: [-15, 10],
                        size: [100, 100],
                    },
                    text: {
                        textAlign: 'center',
                        textBaseline: 'middle',
                        font: 'normal  14px  Microsoft YaHei-Regular, Microsoft YaHei',
                        text: '',
                        offsetY: 32,
                        offsetX: 0,
                        fill: { color: '#FFFFFF' },
                        stroke: { color: '#000', width: 1 },
                        padding: [2, 5, 2, 5],
                    },
                };
            }
        },

        // 更新地图缩放级别
        changeZoom (evt) {
            try {
                if (this.map && this.map.getView()) {
                    const zoom = this.map.getView().getZoom();
                    this.mapZoom = zoom || 14.5;
                }
            } catch (e) {
                console.error('获取地图缩放级别失败:', e);
                this.mapZoom = 14.5;
            }
        },

        // 重置地图视图（兜底，避免空白）
        async resetMapView () {
            try {
                const map = this.map || (await this.getMap());
                if (!map || !map.getView()) return;

                const view = map.getView();
                const center = view.getCenter();
                const zoom = view.getZoom() || 14.5;

                // 安全重置：分步设置，避免一次性修改引发渲染异常
                view.setZoom(zoom);
                setTimeout(() => {
                    view.setCenter(center);
                    this.moveDangerLayersToTop(); // 重置后重新置顶图层
                    map.render(); // 强制刷新渲染
                }, 100);
            } catch (error) {
                console.error('重置地图视图失败:', error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.command-overlayer-danger-top {
    z-index: 9999 !important;
    position: relative;
}

::v-deep .el-popover.caseDialog-popver {
    background-color: transparent !important;
    z-index: 10000 !important;
    pointer-events: auto !important;
    border: none;
    padding: 0 !important;

    .popper__arrow,
    .popper__arrow::after {
        display: none !important;
    }

    .caseDialog {
            width: 420px;
            color: #fff;
            background: rgba(7, 17, 80, 0.75);
            background-clip: padding-box;
            border-top: 5px solid transparent;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-image: url(../../../mainPage/components/imgs/top_start_mask.svg) 10 stretch;
            overflow: hidden;
            border-radius: 4px 4px 0 0;
            box-shadow: none;

        .caseDialog-title {
            padding-left: 10px;
            font-weight: bold;
            line-height: 40px;
            font-size: 18px;
            cursor: move;
            user-select: none;
            border-bottom: 1px solid rgba(73, 240, 253, 0.5);
        }

        .caseDialog-content {
            padding: 10px;
        }
}
}

.point-top.danger {
    background: rgba(152, 17, 2, 0.6);
    border: 1px solid #ff2d15;
    box-shadow: inset 0px 1px 9px 0px rgba(255, 45, 21, 0.4);
    z-index: 9999 !important;
    padding: 2px 8px;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    position: relative;
}
</style>
